import * as Yup from 'yup';
export default function InputsValidations() {
    Yup.addMethod(Yup.string, 'firstCapitalLetter', function () {
        return this.test('primera-letra-mayuscula', 'La primera letra debe ser con mayuscula',
            function (value) {
                if (value && value.length > 0) {
                    const firstLetter = value.substring(0, 1);
                    return firstLetter === firstLetter.toUpperCase();
                }
                return true;
            }
        )
    })
    Yup.addMethod(Yup.array, 'validateArray', function () {
        return this.test('validate-array', 'Campo requerido',
            function (value) {              
                if (value && Array.isArray(value) && value.length > 0) {
                    if (value[0].text === undefined) {
                        return false;
                    } else
                        return true;
                } else {
                    return false;
                }
            }
        )
    })
}